import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReasoningEffort } from "services/aiThread";

interface AiChatsState {
  showDebugTrace: boolean;
  reasoningEffort: ReasoningEffort;
}

const initialState: AiChatsState = {
  showDebugTrace: false,
  // Matches the agent service default so untouched chats behave as before.
  reasoningEffort: "low",
};

const aiChatsSlice = createSlice({
  name: "aiChats",
  initialState,
  reducers: {
    setShowDebugTrace(state, action: PayloadAction<boolean>) {
      state.showDebugTrace = action.payload;
    },
    setReasoningEffort(state, action: PayloadAction<ReasoningEffort>) {
      state.reasoningEffort = action.payload;
    },
  },
});

export const { setShowDebugTrace, setReasoningEffort } = aiChatsSlice.actions;
export const aiChatsSliceActions = aiChatsSlice.actions;
export default aiChatsSlice.reducer;
